import en from "../translations/en/default";
import zodEn from "../translations/en/zod";

/**
 * 翻訳リソースの型定義
 */
export type TranslationResources = {
  [language: string]: {
    [namespace: string]: Record<string, unknown>;
  };
};

/**
 * 名前空間の定義
 */
export const NAMESPACES = {
  DEFAULT: "translation",
  ZOD: "zod",
} as const;

type NamespaceKey = keyof typeof NAMESPACES;
export type Namespace = (typeof NAMESPACES)[NamespaceKey];

// 後方互換性のために残す
export const defaultNS = NAMESPACES.DEFAULT;
export const zodNS = NAMESPACES.ZOD;

/**
 * 初期読み込み翻訳リソースの定義
 */
export const INITIAL_TRANSLATION_RESOURCES = {
  "en-US": {
    [NAMESPACES.DEFAULT]: en,
    [NAMESPACES.ZOD]: zodEn,
  },
};

/**
 * 翻訳リソースの型を取得
 */
export type TranslationResource =
  (typeof INITIAL_TRANSLATION_RESOURCES)[keyof typeof INITIAL_TRANSLATION_RESOURCES][Namespace];

/**
 * デフォルト名前空間の翻訳型
 */
export type DefaultTranslationType = TranslationResource;

/**
 * ネストされたオブジェクトのキーを再帰的に取得
 */
type RecursiveKeyOf<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${RecursiveKeyOf<T[K]>}`
          : K
        : never;
    }[keyof T]
  : never;

/**
 * 特定の名前空間の翻訳キーの取得
 */
export type TranslationKey<NS extends Namespace> =
  NS extends typeof NAMESPACES.DEFAULT
    ? RecursiveKeyOf<typeof en>
    : NS extends typeof NAMESPACES.ZOD
      ? RecursiveKeyOf<typeof zodEn>
      : never;

type CustomZodKey = TranslationKey<typeof NAMESPACES.ZOD>;

/**
 * zod国際化対応のエラーパラメータを生成する
 */
export const createI18nZodParams = (
  key: CustomZodKey,
  values?: Record<string, unknown>,
) => ({
  params: {
    i18n: {
      key,
      values,
    },
  },
});
